import React from 'react';
import { Backdrop, Box, ClickAwayListener } from '@mui/material';

const OverlayWrapper = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <Backdrop
      open={open}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Box
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: 2,
            padding: 3,
            minWidth: '300px',
            maxWidth: '90%',
            maxHeight: '90%',
            overflowY: 'auto',
            boxShadow: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {children}
        </Box>
      </ClickAwayListener>
    </Backdrop>
  );
};

export default OverlayWrapper;
